import script from "./cancelBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./cancelBooking.vue?vue&type=script&setup=true&lang=js"

import "./cancelBooking.vue?vue&type=style&index=0&id=f0a9a1be&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0a9a1be"]])

export default __exports__